export default class PersonDegreeProgramDomainService {
    static fromJSON(json) {
        // @ts-expect-error - TS2739 - Type '{ startDate: any; endDate: any; }' is missing the following properties from type 'PersonDegreeProgram': degree, program, major, status
        return Object.assign(Object.assign({}, json), { startDate: json.startDate && new Date(json.startDate), endDate: json.endDate && new Date(json.endDate) });
    }
}
